import {
    planlist, activePlanlist, mySubscriptionPlanData, setInitialSubsPlanDays, extendSubscriptionDays, createSubscriptionPlan,
    renewSubscriptionPlan, chargePayment, savePaymentData, subscriptionPlanPrice, subscriptionInvoice, createSubscriptionPrice,
    allplanlist, renewBulkSubscriptionPlan, subsControllerlist, subsControllerPaymentDetails, updateSubsPlanPrice, getDealers,
    getDealersTeam, defaultSubscriptionPlan, allAssignedDiscountList, assignSubscriptionDiscount, getTeamDiscount, updateSubsAssignedDiscount,
    getDiscountList, addDiscountLabel, updateDiscountLabel, activeDiscountLabel, updateDefaultSubsPlan, downloadInvoice, addAchCustomer, 
    achPaymentCharge, verifyAchCustomer } from "../api"
import * as SubscriptionAPI from "../api"    // import all functions from API file
import { AppError } from "../models"
import { NOT_FOUND, SUBS_HELPER_CONSTLIST } from '../constants'
 
export let getPlanList = async (token) => {

    let response = {}

    try {
        let controllers = await planlist(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSLIST)
        response = { error: appError }
    }

    return response
}

export let getActivePlanList = async (token) => {

    let response = {}

    try {
        let controllers = await activePlanlist(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSLIST)
        response = { error: appError }
    }

    return response
}

export let getMySubscriptionPlan = async (token, controllerId) => {
    let response = {}
    try {
        let controllers = await mySubscriptionPlanData(token, controllerId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSDATA)
        response = { error: appError }
    }

    return response
}

export let setInitialSubsDays = async (token, subsPlanDaysValue, selectPlanID) => {

    let response = {}

    try {
        let controllers = await setInitialSubsPlanDays(token, subsPlanDaysValue, selectPlanID)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_FREEDAYS)
        response = { error: appError }
    }

    return response
}

export let extendSubsDays = async (token, controllerID, extendSubsVal) => {

    let response = {}

    try {
        let controllers = await extendSubscriptionDays(token, controllerID, extendSubsVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_EXTEND, SUBS_HELPER_CONSTLIST.UNABLE_EXTEND_FREEDAYS)
        response = { error: appError }
    }

    return response
}

export let createSubsPlan = async (token, planNameVal, isFreePlan, freePlanVal) => {

    let response = {}

    try {
        let controllers = await createSubscriptionPlan(token, planNameVal, isFreePlan, freePlanVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_CREATED, SUBS_HELPER_CONSTLIST.UNABLE_CREATE_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let renewSubsPlan = async (token, controllerID) => {

    let response = {}

    try {
        let controllers = await renewSubscriptionPlan(token, controllerID)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_RENEWED, SUBS_HELPER_CONSTLIST.UNABLE_RENEW_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let renewBulkSubsPlan = async (token, bulk_subsData) => {

    let response = {}

    try {
        let controllers = await renewBulkSubscriptionPlan(token, bulk_subsData)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_RENEWED, SUBS_HELPER_CONSTLIST.UNABLE_RENEW_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let chargeSubsPlan = async (token, amount, tokenID) => {

    let response = {}

    try {
        let controllers = await chargePayment(token, amount, tokenID)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, SUBS_HELPER_CONSTLIST.UNABLE_RENEW_SUBSPLAN)
        response = { error: appError }
    }

    return response
}


export let savePayment = async (token, transactionID, transDetails, randomTransactionId, paidBy, controllerID) => {

    let response = {}

    try {
        let controllers = await savePaymentData(token, transactionID, transDetails, randomTransactionId, paidBy, controllerID)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_SAVED, SUBS_HELPER_CONSTLIST.UNABLE_SAVE_PAYMENt)
        response = { error: appError }
    }

    return response
}

export let getSubscriptionPlanPrice = async (token, subsPlanId, subsPlanYear) => {

    let response = {}

    try {
        let controllers = await subscriptionPlanPrice(token, subsPlanId, subsPlanYear)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSPRICE)
        response = { error: appError }
    }

    return response
}

export let getInvoiceData = async (token, teamArr) => {

    let response = {}

    try {
        let invoiceResponse = await subscriptionInvoice(token, teamArr)
        response = invoiceResponse
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_INVOICE)
        response = { error: appError }
    }

    return response
}

export let createSubsPrice = async (token, planId, planPrice, planYear) => {

    let response = {}

    try {
        let controllers = await createSubscriptionPrice(token, planId, planPrice, planYear)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_CREATED, SUBS_HELPER_CONSTLIST.UNABLE_CREATE_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let getAllPlanList = async (token) => {

    let response = {}

    try {
        let controllers = await allplanlist(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let getSubscriptionControllers = async (token) => {

    let response = {}

    try {
        let controllers = await subsControllerlist(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_SUBSCONTROLLER)
        response = { error: appError }
    }

    return response
}

export let getPaymentHistory = async (token, controllerId) => {

    let response = {}

    try {
        let controllers = await subsControllerPaymentDetails(token, controllerId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_PAYMENT)
        response = { error: appError }
    }

    return response
}

export let updatePlanPrice = async (token, subsPlanPrice, subsPlanYear, selectPlanID) => {

    let response = {}

    try {
        let controllers = await updateSubsPlanPrice(token, subsPlanPrice, subsPlanYear, selectPlanID)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_PLANPRICE)
        response = { error: appError }
    }

    return response
}

export let getDealersList = async (token) => {

    let response = {}

    try {
        let controllers = await getDealers(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DEALERS)
        response = { error: appError }
    }

    return response
}

export let getDealersTeamList = async (token, dealerIdArr) => {

    let response = {}

    try {
        let controllers = await getDealersTeam(token, dealerIdArr)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DEALER_TEAMLIST)
        response = { error: appError }
    }

    return response
}

export let getDefaultSubsPlan = async (token) => {

    let response = {}

    try {
        let controllers = await defaultSubscriptionPlan(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DEFAULT_SUBSPLAN)
        response = { error: appError }
    }

    return response
}

export let getAllAssignedDiscountList = async (token) => {

    let response = {}

    try {
        let controllers = await allAssignedDiscountList(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DISCOUNT_LIST)
        response = { error: appError }
    }

    return response
}

export let assignSubsDiscount = async (token, teamId, discountVal) => {

    let response = {}

    try {
        let controllers = await assignSubscriptionDiscount(token, teamId, discountVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_ASSIGNED, SUBS_HELPER_CONSTLIST.UNABLE_ASSIGN_DISCOUNT_TEAM)
        response = { error: appError }
    }

    return response
}

export let getSingleDiscount = async (token, teamId) => {

    let response = {}

    try {
        let controllers = await getTeamDiscount(token, teamId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DISCOUNT_TEAM)
        response = { error: appError }
    }

    return response
}

export let updateAssignedDiscount = async (token, teamId, discountId) => {

    let response = {}

    try {
        let controllers = await updateSubsAssignedDiscount(token, teamId, discountId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_DISCOUNT_TEAM)
        response = { error: appError }
    }

    return response
}

export let getDiscountLabelList = async (token) => {

    let response = {}

    try {
        let controllers = await getDiscountList(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_DISCOUNT_LIST)
        response = { error: appError }
    }

    return response
}

export let createDiscountLabel = async (token, discountLabel, discountVal) => {

    let response = {}

    try {
        let controllers = await addDiscountLabel(token, discountLabel, discountVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_CREATED, SUBS_HELPER_CONSTLIST.UNABLE_CREATE_DISCOUNT_LABEL)
        response = { error: appError }
    }

    return response
}

export let editDiscountLabel = async (token, discountLabelId, discountVal) => {

    let response = {}

    try {
        let controllers = await updateDiscountLabel(token, discountLabelId, discountVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_DISCOUNT)
        response = { error: appError }
    }

    return response
}

export let statusDiscountLabel = async (token, discountLabelId, discounLabelStatus) => {

    let response = {}

    try {
        let controllers = await activeDiscountLabel(token, discountLabelId, discounLabelStatus)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_CHANGE_DISCOUNT)
        response = { error: appError }
    }

    return response
}

export let editDefaultSubsPlan = async (token,  selectPlanID, selectPlanIdPkId) => {

    let response = {}

    try {
        let controllers = await updateDefaultSubsPlan(token, selectPlanID, selectPlanIdPkId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_DEFAULT_PLAN)
        response = { error: appError }
    }

    return response
}

export let createDownloadInvoice = async (token, dealerTeamId, invoiceNo, downloadInvoiceNo, downloadType="Invoice", listControllers=[]) => {

    let response = {}

    try {
        let downloadResponse = await downloadInvoice(token, dealerTeamId, invoiceNo, downloadInvoiceNo, downloadType, listControllers)
        response = downloadResponse
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_DOWNLOAD, SUBS_HELPER_CONSTLIST.UNABLE_DOWNLOAD_INVOICE)
        response = { error: appError }
    }

    return response
}

export let achCustomer = async (token, sourceId, descVal) => {

    let response = {}

    try {
        let controllers = await addAchCustomer(token, sourceId, descVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, SUBS_HELPER_CONSTLIST.UNABLE_CREATE_CUSTOMER)
        response = { error: appError }
    }

    return response
}

export let verifyAch = async (token, custId, sourceId) => {

    let response = {}

    try {
        let controllers = await verifyAchCustomer(token, custId, sourceId)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, SUBS_HELPER_CONSTLIST.UNABLE_VERIFY_CUSTOMER)
        response = { error: appError }
    }

    return response
}

export let achCharge = async (token, customerId, amount) => {

    let response = {}

    try {
        let controllers = await achPaymentCharge(token, customerId, amount)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.PAYMENT_FAIL, SUBS_HELPER_CONSTLIST.UNABLE_RENEW_SUBSPLAN)
        response = { error: appError }
    }

    return response
}



/** This function is used to get all expired controllers from API **/
export let getExpiredControllers = async (token) => {

    let response = {}

    try {
        let controllers = await SubscriptionAPI.subsExpiredControllers(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_EXPIRED_CONTROLLER)
        response = { error: appError }
    }

    return response
}

/** This function is used to get all about to expire controllers from API **/
export let getExpiringControllers = async (token) => {

    let response = {}

    try {
        let controllers = await SubscriptionAPI.subsAboutExpireControllers(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_ABOUT_EXPIRED)
        response = { error: appError }
    }

    return response
}

/** This function is used to get payment history of a given month from API **/
export let getPaymentsReport = async (token, startDateVal, endDateVal) => {

    let response = {}

    try {
        let controllers = await SubscriptionAPI.subsPaymentsReport(token, startDateVal, endDateVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_PAYMENT_REPORT)
        response = { error: appError }
    }

    return response
}

/** This function is used to get all renewed controller from API **/
export let getRenewedControllers = async (token) => {

    let response = {}

    try {
        let controllers = await SubscriptionAPI.subsRenewedController(token)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(NOT_FOUND, SUBS_HELPER_CONSTLIST.UNABLE_FIND_RENEWED_CONTROLLER)
        response = { error: appError }
    }

    return response
}

/** This function is used to set about to expire days from API **/
export let setAboutExpireDays = async (token, defaultPkId, expireDaysTxtVal) => {

    let response = {}

    try {
        let controllers = await SubscriptionAPI.updateAboutExpireDays(token, defaultPkId, expireDaysTxtVal)
        response = controllers
    } catch (error) {
        console.log(error)
        let appError = new AppError(SUBS_HELPER_CONSTLIST.NOT_UPDATE, SUBS_HELPER_CONSTLIST.UNABLE_UPDATE_EXPIRING_DAYS)
        response = { error: appError }
    }

    return response
}


// WEBPACK FOOTER //
// ./src/dataHelpers/subscriptionHelpers.js